<template>
    <div class="daily-deals-wrap">
        <ProductGridSkeleton :show-bg-header="true" :show-banner="false" v-if="!isFetchingProductsFlashSale"></ProductGridSkeleton>

        <div v-else>
            <div class="daily-deals-header mb-2 d-flex align-items-center justify-content-between">
                <div class="deals-header-left">
                    <div class="deals-section-title">
                        <svg width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M3.14518 0.0124512L-0.0010376 15.1035L3.96374 14.9588L3.57502 24.9865L11.8085 11.311L7.29626 11.1455L11.9703 0.518261L3.14518 0.0124512Z"
                                fill="black"/>
                        </svg>

                        <h2 class="section-title" v-html="title"></h2>
                    </div>
                    <div class="deals-section-countdown">
                        <span v-html="message"></span>
                        <div class="deals-countdown pl-2"></div>
                    </div>
                </div>
                <div class="deals-section-right">
                    <a class="btn px-2 px-md-4" :href="route('public.flashsale.index')">{{ $trans('ecommerce::layout.view_all') }}</a>
                </div>
            </div>

            <div class="daily-deals slick-center-items" ref="productsPlaceholder" v-if="products.length > 0">
                <FlashSaleProductCard v-for="product in products" :key="product.id" :product="product" :mask="maskPrice"/>
            </div>

            <div class="d-flex align-items-center justify-content-center" v-else>
                <div>
                    <img height="300" :src="iconEmptyUrl" alt="">
                    <div class="text-center">{{$trans('ecommerce::layout.no_data')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FlashSaleProductCard from './FlashSaleProductCard.vue';
import { slickPrevArrow, slickNextArrow } from '../../functions';
import ProductGridSkeleton from './SkeletonLoader/ProductGridSkeleton.vue';


export default {
    components: { FlashSaleProductCard, ProductGridSkeleton },

    props: ['title', 'url'],

    data() {
        return {
            products: [],
            until: '',
            message: '',
            maskPrice: 0,
            isFetchingProductsFlashSale: false,
        };
    },
    mounted() {},
    computed: {
          iconEmptyUrl() {
            return `${window.FleetCart.baseUrl}/themes/ecommerce/public/images/icon-empty.svg`;
        },
    },
    created() {
        $.ajax({
            method: 'GET',
            url: this.url,
        }).then((res) => {
            this.products = res['products'] || [];
            this.until = res['until'];
            this.message = res['message'];

            this.isFetchingProductsFlashSale = true;

            if (res['type'] != 'in') {
                this.maskPrice = 1;
            } else {
                 this.maskPrice = 0;
            }

            setTimeout(() => {
                if (this.until) {
                    const time = this.until.split(":");
                    const now = new Date();
                    now.setHours(time[0], time[1], 0);
                    if (res.nextday) {
                        now.setDate(new Date().getDate() + 1);
                    }

                    $(this.$el).find('.deals-countdown').countdown({
                        until: now,
                        format: 'HMS',
                        compact: true,
                    });

                }
            }, 100);

            this.$nextTick(() => {
                $(this.$refs.productsPlaceholder).slick(this.slickOptions());
            });
        }).catch((xhr) => {
            this.isFetchingProductsFlashSale = false;
            this.$notify(xhr.responseJSON.message);
        });
    },

    methods: {
        slickOptions() {
            return {
                rows: 0,
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 7,
                slidesToScroll: 7,
                rtl: window.FleetCart.rtl,
                prevArrow: slickPrevArrow(),
                nextArrow: slickNextArrow(),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            dots: false,
                            arrows: false,
                            slidesToShow: 3.5,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 577,
                        settings: {
                            dots: false,
                            arrows: false,
                            slidesToShow: 2.2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        },
    },
};
</script>
